export const mapRecipesToCommercialProductsPayload = (recipes) => {
  const products = [];
console.log('recipes',recipes)
  recipes.forEach(recipe => {
    const commercialProducts = recipe.products?.commercial || [];

    commercialProducts.forEach(product => {
      products.push({
        id_pharol: Number(product.sku),
        recipe_id: recipe.id,
        quantity: product.quantity
      });
    });
  });

  return { products };
};